import { GridGame, type GridGameConfig } from "./GridGame";
import type { GuessRow } from "../components/wordle/keystate";

interface View {
  guesses: GuessRow[];
  maxGuesses: number;
  solution?: string;
}

const UK_ROWS: string[][] = [
  ["й", "ц", "у", "к", "е", "н", "г", "ш", "щ", "з", "х", "ї"],
  ["ф", "і", "в", "а", "п", "р", "о", "л", "д", "ж", "є"],
  ["'", "я", "ч", "с", "м", "и", "т", "ь", "б", "ю", "ґ", "back"],
];
const UK_CHAR = /^[абвгґдеєжзиіїйклмнопрстуфхцчшщьюя']$/;

const CONFIG: GridGameConfig<View> = {
  game: "slovko",
  title: "СЛОВКО",
  cols: 5,
  rows: (v) => v.guesses,
  errorCopy: {
    invalid_word: "Нема такого слова",
    not_in_dictionary: "Нема такого слова",
  },
  shakeCodes: ["invalid_word", "not_in_dictionary"],
  tooShort: "Замало літер",
  charOk: (k) => UK_CHAR.test(k),
  mapKey: (e) => (e.key === "’" || e.key === "ʼ" ? "'" : null),
  keyboardRows: UK_ROWS,
  shareTitle: "Словко",
  lostSubtitle: (v) => `слово було ${v.solution?.toUpperCase() ?? "?"}`,
  board: "notebook",
  answer: (v) => v.solution,
};

export function Slovko({ date }: { date?: string | undefined }) {
  return <GridGame config={CONFIG} date={date} />;
}
